import script from "./CustomTableDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomTableDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./CustomTableDropdown.vue?vue&type=style&index=0&id=7360ba1f&scoped=true&lang=scss"
import "./CustomTableDropdown.vue?vue&type=style&index=1&id=7360ba1f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7360ba1f"]])

export default __exports__